// Competition pictures are stored twice (see optimiseImage.js): the full
// picture, `…-full.jpg` (or `-full.png` when it has see-through parts), and an
// 800-pixel WebP next to it, `…-card.webp`, for cards and thumbnails. Pictures
// stored before 4 Nov 2026, or without a card copy, are used as they are.

const FULL = /-full\.(jpg|png)$/i;

/** The small copy of a competition picture, for cards and thumbnails. */
export function cardImageUrl(url) {
  return typeof url === 'string' && FULL.test(url) ? url.replace(FULL, '-card.webp') : url;
}
